import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initialiseBrowserPdfPrinting } from "@/utils/browserPdfPrint";
import "@/utils/holdRegisterEnhancements";

// Add a browser print action beside existing controlled PDF downloads.
initialiseBrowserPdfPrinting();

// Register service worker for offline support.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
        window.registration = registration;

        // Explicitly check on app load so frontend releases are discovered
        // promptly instead of relying only on the browser's update cadence.
        registration.update().catch((error) => {
          console.log('SW update check failed:', error);
        });

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('New service worker installed; fresh pages will be used on the next navigation.');
            }
          });
        });
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
